import React from "react";
import { useTranslation } from "react-i18next";
import "./StartingDev.css";

function StartingDev() {
  const { t } = useTranslation();
  return (
    <div className="starting-dev">
      <h1>{t("startingDev.title")}</h1>
      <p className="starting-dev-intro">
        {t("startingDev.intro")}
      </p>

      <section className="starting-dev-section">
        <h2>{t("startingDev.satochipTitle")}</h2>
        <p>
          <a
            href="https://satochip.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="satochip-link"
          >
            Satochip
          </a>{" "}
          {t("startingDev.satochipDesc1")}
        </p>
        <p>
          {t("startingDev.satochipDesc2")}
        </p>
      </section>

      <section className="starting-dev-section">
        <h2>{t("startingDev.overviewTitle")}</h2>
        <p>
          {t("startingDev.overviewDesc")}
        </p>
      </section>

      <section className="starting-dev-section coming-soon">
        <h2>📝 {t("startingDev.comingSoonTitle")}</h2>
        <p>
          {t("startingDev.comingSoonDesc")}
        </p>
        <ol className="steps-list">
          <li>{t("startingDev.comingSoonStep1")}</li>
          <li>{t("startingDev.comingSoonStep2")}</li>
          <li>{t("startingDev.comingSoonStep3")}</li>
          <li>{t("startingDev.comingSoonStep4")}</li>
          <li>{t("startingDev.comingSoonStep5")}</li>
          <li>{t("startingDev.comingSoonStep6")}</li>
          <li>{t("startingDev.comingSoonStep7")}</li>
        </ol>
        <p className="coming-soon-note">
          {t("startingDev.comingSoonNote")}
        </p>
      </section>
    </div>
  );
}

export default StartingDev;

